export const HANDOVER_SESSION_KEY = "handoverSession";
export const LOGOUT_TIMER_REFRESH = "logoutTimerRefresh";

export const refreshLogoutTimer = () => {
  localStorage.setItem("logoutModalStart", String(Date.now()));
  window.dispatchEvent(new Event(LOGOUT_TIMER_REFRESH));
};

export const refreshLogoutTimerForHandover = () => {
  localStorage.setItem(HANDOVER_SESSION_KEY, "true");
  refreshLogoutTimer();
};
